import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-counselors',
  templateUrl: './counselors.component.html',
  styleUrls: ['./counselors.component.css']
})
export class CounselorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
